import React from "react"
import PropTypes from "prop-types"
import Block from "@bappweb/block"
import Button from "@bappweb/button"
import Link from "@bappweb/link"

const Toolbar = (props) => {

  return props.isVisible ? (
    <Block className="fixed-toolbar">
      <Block className="fixed-toolbar-content">
        <Link href={props.scrollHref}>
          <Button text={props.text} onClick={props.onApplyClick} />
        </Link>
      </Block>
    </Block>
  ) : null
}

Toolbar.propTypes = {
  isVisible: PropTypes.bool,
  onApplyClick: PropTypes.func,
  text: PropTypes.string,
  scrollHref: PropTypes.string,
}

export default Toolbar
